import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useEffect, useMemo, useState} from 'react';
import {Platform, View} from 'react-native';
import {connect} from 'react-redux';
import {WARNING} from '../../../../../data/constants/warning';
import {ApiResponse} from '../../../../../data/types/interface/api';
import {
  IDataWs,
  IDisplay,
} from '../../../../../data/types/interface/contratFamille';
import {StackParams} from '../../../../../data/types/navigation';
import mapDispatchToProps from '../../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../../../components/Header/HeaderScreen';
import Label from '../../../../components/Label';
import {Loader} from '../../../../components/Loader';
import ConfirmationModal from '../../../../components/Modal/ConfirmationModal';
import {ProduitItem} from '../../../../components/ProduitItem';
import globalStyle from '../../../../styles/globalStyle';
import {styles} from '../styles';

type NavigationProps = StackNavigationProp<
  StackParams,
  'SouscriptionMenuVoyage'
>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function FamilleContratScreen(props: any) {
  const {getTypeassurance} = props;
  const categorieId =
    props && props.route && props.route.params && props.route.params.id;

  const [listItem, setListItem] = useState<Array<IDataWs>>();
  const [information, setInformation] = React.useState<{
    status: boolean;
    accept: boolean;
  }>({status: false, accept: false});
  const [rapatriementInformation, setRapatriementInformation] = React.useState<{
    status: boolean;
    accept: boolean;
  }>({status: false, accept: false});
  const {navigate} = useNavigation<NavigationProps>();

  useEffect(() => {
    getTypeassurance(
      {},
      (res: ApiResponse) => {
        setListItem(res && res.data && res.data.items);
      },
      `?categorieId=${categorieId}`,
    );
  }, [getTypeassurance]);

  const datas = useMemo(
    () =>
      listItem
        ? listItem.map(item => {
            let destinationPage = undefined;
            let action = undefined;
            if (item.nom.trim().toLowerCase() === 'assurance scolaire') {
              destinationPage = 'SouscriptionAssuranceScolaireForm';
            } else if (
              item.nom.trim().toLowerCase() === 'assurance rc vie privée'
            ) {
              destinationPage = 'SouscriptionAssuranceRCVPForm';
            } else if (item.nom.trim().toLowerCase() === 'assurance voyage') {
              action = () => setInformation({accept: false, status: true});
            } else if (
              item.nom.trim().toLowerCase() === 'assurance obsèques à dago'
            ) {
              action = () =>
                setRapatriementInformation({accept: false, status: true});
            }
            return {
              libelle: item.nom,
              id: item.id,
              imageUrl: item.imageUrl ?? '',
              destinationPage,
              action,
            };
          })
        : [],
    [listItem],
  );

  const display: IDisplay = {items: []};

  display.items = datas;

  const containerStyle =
    Platform.OS === 'web' ? globalStyle.containerFluid : styles.ListContainer;

  const changeStateData = () => {
    // information.accept && flowSouscriptionVoyage('true', (res: any) => {});
    setInformation({accept: true, status: false});
    navigate('SouscriptionMenuVoyage');
  };

  const changeStateRapatriementData = () => {
    setRapatriementInformation({accept: true, status: false});
    navigate('DemanderDevisAssuranceRapatriement');
  };

  return (
    <View style={{flex: 1}}>
      {information.status && (
        <ConfirmationModal
          title="Information"
          content={WARNING.voyage}
          btn1="OK"
          handleBtn1={changeStateData}></ConfirmationModal>
      )}
      {rapatriementInformation.status && (
        <ConfirmationModal
          title="Information"
          content={WARNING.rapatriement}
          btn1="OK"
          handleBtn1={changeStateRapatriementData}></ConfirmationModal>
      )}
      <HeaderScreen
        title="Compte > Souscrire un Contrat > Famille"
        type="retour"
        noBreadcrumb={false}
      />
      <View style={containerStyle}>
        <View style={styles.ListLibelle}>
          <Label title="FAMILLE" type="mainTitle" />
        </View>
        {display.items.length <= 0 ? (
          <Loader />
        ) : (
          <ProduitItem data={display} />
        )}
      </View>
    </View>
  );
}
export const FamilleContrat = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FamilleContratScreen);
